import React, { Component } from "react";
import {
  GET,
  POST,
  loading,
  alert,
  profile,
  Modal,
  mode,
  setDarkMode,
  linkRole
} from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import QRCode from "react-qr-code";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_auth: false,
      modal_howto: false,
      token: "",
      profiles: profile,
    };
  }
  async componentDidMount() {
    if (mode === "dark") {
      setDarkMode();
    }
    if (!profile?.verify_time || profile?.verify_time < new Date().getTime()) {
      localStorage.clear();
      window.location.href = "/";
    }
    // backend ใหม่: token ชั่วคราวก่อนยืนยัน 2FA เรียก profile ไม่ได้ (401) แต่ login ส่ง full_name/email มาเก็บไว้แล้ว
    // มีครบ = ข้ามการยิง · ยิงแล้วล้มเหลว = เงียบ ใช้หน้าต่อได้ (ห้ามล้าง localStorage/redirect)
    if (!profile?.full_name || !profile?.email) {
      const result = await GET("v1/admin/users/profile", null, { silent: true });
      if (result?.status) {
        localStorage.setItem(
          "scp-profile",
          JSON.stringify({ ...result.data, verify_time: profile.verify_time })
        );
        this.setState({
          profiles: { ...result.data, verify_time: profile.verify_time },
        });
      }
    }
    loading(false);
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
  }
  Verify2FA = async () => {
    const { token } = this.state;
    if (!token) {
      alert("", "warning", "Warning", "Please Input 2FA Token");
      return;
    }
    loading(true);
    let result = await POST("v1/public/verify-2fa", {
      token: token,
    });
    if (result?.result?.status) {
      localStorage.setItem(
        "scp-2fa",
        btoa(
          profile?.uid +
            ":" +
            new Date(new Date().setDate(new Date().getDate() + 7)).getTime()
        )
      );

      loading(false);
      window.location.href = `/${linkRole(profile.user_type)}/dashboard`;
    } else {
      this.setState({ token: "" });
      loading(false);
      alert(
        "",
        "warning",
        "Error",
        "Your 2FA code is invalid. Please try again."
      );
    }
  };

  render() {
    const { modal_auth, modal_howto, token, profiles } = this.state;
    return (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div
            className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}
          >
            <img
              alt="logo"
              src={LOGO}
              className="w-75"
              style={{ minWidth: 350 }}
            />
          </div>
          <div
            className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}
          >
            <img
              alt="logo"
              src={LOGO}
              style={{ width: "60%", minWidth: 400 }}
            />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5 auth-card text-center">
              <div className="w-100 bg-light rounded-4 p-3 mb-5 d-flex">
                <div className="wpx-50 hpx-50 rounded-circle bg-primary-light text-center align-content-center">
                  <h3 className="mb-0 text-primary">
                    {profiles?.full_name?.slice(0, 2).toUpperCase() || "US"}
                  </h3>
                </div>
                <div className="px-2">
                  <h5 className="fw-bold">{profiles?.full_name}</h5>
                  <label>{profiles?.email}</label>
                </div>
              </div>

              <h3 className="fw-bold text-dark mb-3">
                Two-Factor Authentication
              </h3>
              <div className="d-flex justify-content-center mb-5">
                {Array.from({ length: 6 }).map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength="1"
                    className="form-control text-center mx-1"
                    style={{ width: "3rem", fontSize: "1.5rem" }}
                    value={token[index] || ""}
                    onChange={(e) => {
                      let val = e.target.value.replace(/[^0-9]/g, "");
                      let newToken = token.split("");
                      newToken[index] = val;
                      const updatedToken = newToken.join("");
                      this.setState({ token: updatedToken }, () => {
                        if (val && index < 5) {
                          document.getElementById(`otp-${index + 1}`).focus();
                        }
                        if (updatedToken.length === 6) {
                          this.Verify2FA();
                        }
                      });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !token[index] && index > 0) {
                        document.getElementById(`otp-${index - 1}`).focus();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const paste = e.clipboardData
                        .getData("text")
                        .replace(/[^0-9]/g, "");
                      if (paste.length === 6) {
                        this.setState({ token: paste }, () => {
                          this.Verify2FA();
                        });
                      } else {
                        let newToken = token.split("");
                        paste.split("").forEach((char, i) => {
                          if (index + i < 6) {
                            newToken[index + i] = char;
                          }
                        });
                        this.setState({ token: newToken.join("") }, () => {
                          const nextIndex = Math.min(index + paste.length, 5);
                          document.getElementById(`otp-${nextIndex}`).focus();
                        });
                      }
                    }}
                    id={`otp-${index}`}
                  />
                ))}
              </div>

              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-link mb-5 text-decoration-none text-dark"
                  onClick={async () => {
                    if (
                      await alert(
                        "",
                        "warning",
                        "Warning",
                        "Are you sure you want to return to login?",
                        "Confirm",
                        "Cancel"
                      )
                    ) {
                      localStorage.clear();
                      window.location.href = "/";
                    }
                  }}
                >
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <div
          className="position-absolute d-flex"
          style={{ right: 8, bottom: 8 }}
        >
          <a
            href="#"
            className="text-decoration-none text-secondary text-14 ms-4"
            onClick={() => this.setState({ modal_howto: true })}
          >
            How to Connect Authentication
          </a>
        </div> */}

        <Modal
          show={modal_auth}
          onHide={() => this.setState({ modal_auth: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">Two-Factor Authentication</h5>
          </Modal.Header>
          <Modal.Body className="position-relative">
            <div className="position-relative">
              {/* QR Code */}
              {profiles?.email && (
                <QRCode
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={`otpauth://totp/${profiles?.email}?secret=${profiles?.secret}&issuer=SwiftGoldPay (${profiles?.full_name})`}
                  viewBox={`0 0 256 256`}
                />
              )}

              {/* Logo ตรงกลาง */}
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <img
                  src={LOGO} // ใส่ path รูปโลโก้
                  alt="Logo"
                  className="wpx-50 hpx-50 bg-white"
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={modal_howto}
          onHide={() => this.setState({ modal_howto: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">How to Connect Authentication</h5>
          </Modal.Header>
          <Modal.Body className="position-relative">
            <section class="p-3 rounded-4 mb-4 text-center bg-light border rounded">
              <h3 class="fw-bold">How to Enable</h3>
              <h1 class="fw-bold mb-2 text-primary">
                Authentication App (2FA)
              </h1>
              <p class="text-secondary mb-0">
                Enhance your account security with one-time passwords (OTP) from
                an authenticator app.
              </p>
            </section>

            <div
              class="alert alert-info d-flex align-items-start gap-3"
              role="alert"
            >
              <i class="bi bi-shield-lock fs-4"></i>
              <div>
                <strong>Tip:</strong> Keep your <em>Backup Codes</em> safe in
                case you lose your phone or change devices.
              </div>
            </div>

            <div class="mb-3">
              <h2 class="h4 mb-3">Step 1: Download an Authentication App</h2>
              <p class="mb-2">
                Go to <strong>App Store (iOS)</strong> or{" "}
                <strong>Google Play Store (Android)</strong>
              </p>
              <p class="mb-2">Search and install one of the following apps:</p>
              <ul class="mb-0">
                <li>Google Authenticator</li>
                <li>Microsoft Authenticator</li>
                <li>Authy</li>
              </ul>
            </div>

            <div class="mb-3">
              <h2 class="h4 mb-3">Step 2: Sign in</h2>
              <ul class="mb-0">
                <li>
                  Log in with your <strong>Username + Password</strong>.
                </li>
                <li>
                  If 2FA is already connected, you will be redirected to the{" "}
                  <strong>Verify 2FA</strong> page → Open the app → Enter the
                  6-digit code → Access granted.
                </li>
                <li>
                  If not connected yet, click the <strong>Connect</strong>{" "}
                  button located below the <strong>Verify</strong> button.
                </li>
              </ul>
            </div>

            <div class="mb-3">
              <h2 class="h4 mb-3">
                Step 3: Connect with the Authentication App
              </h2>
              <ol class="mb-0">
                <li>
                  Open the <strong>Authenticator</strong> app on your phone.
                </li>
                <li>
                  Tap <strong>Add Account</strong> → Select{" "}
                  <strong>Scan QR Code</strong>.
                </li>
                <li>
                  Use your phone camera to scan the <strong>QR Code</strong>{" "}
                  shown on the website/app.
                </li>
              </ol>
            </div>

            <div class="mb-3">
              <h2 class="h4 mb-3">Step 4: Confirm the Connection</h2>
              <ul class="mb-0">
                <li>
                  After scanning, the app will show a{" "}
                  <strong>6-digit code</strong> that refreshes every{" "}
                  <strong>30 seconds</strong>.
                </li>
                <li>
                  Go back to the website → Enter the 6-digit code to confirm.
                </li>
                <li>
                  If correct, the system will redirect you to your account.
                </li>
              </ul>
            </div>
            <div class="mb-3">
              <h2 class="h4 mb-3">Step 5: Use 2FA When Signing In</h2>
              <ol class="mb-0">
                <li>
                  Enter your <strong>Username + Password</strong>.
                </li>
                <li>
                  The system will ask for the{" "}
                  <strong>code from your Authentication App</strong>.
                </li>
                <li>
                  Open the app → Enter the <strong>6-digit code</strong> →
                  Access granted.
                </li>
              </ol>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
